import { Component, useState } from 'react'
import { Col, Row, Input } from 'reactstrap'
import AdvancedFilters from '../../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../../Filters/filterUrl'

// Advanced filters live in the URL (useAdvancedFilters); this control just hosts the
// popover open/close state so the class header can render the hooks-based popover.
function TPAConfigAdvancedFiltersControl() {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger compact count={advancedFilters.length} onClick={() => setIsOpen(!isOpen)} />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity="tpa_config"
                    context={null}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                />
            )}
        </>
    )
}

class TPAConfigListHeader extends Component {
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    render() {
        return (
            <Row className="pb-2">
                <Col xs={12} className="mt-2">
                    <Row className="align-items-center">
                        <Col xs={6}>
                            <span className="driver-search-filter">
                                <Input
                                    type="text"
                                    name="searchTerm"
                                    placeholder="Search"
                                    onChange={(e) => this.updateSearchTerm(e.target.value)}
                                />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col className="p-0">
                            <TPAConfigAdvancedFiltersControl />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters entity="tpa_config" context={null} />
                </Col>
            </Row>
        )
    }
}

export default TPAConfigListHeader
